import type { CommandAction } from '../../types/CommandAction.js';
import { readUserPreferences } from '@ms-cloudpack/config';

/** List Cloudpack user preferences. */
export const execute: CommandAction<never> = async () => {
  try {
    const userPreferences = await readUserPreferences();
    return {
      message: Object.entries(userPreferences)
        .map(([key, value]) => `${key}: ${value}`)
        .join('\n'),
    };
  } catch (err) {
    return {
      hasErrors: true,
      message: `Failed to list preferences: ${(err as Error).message || err}`,
    };
  }
};
